import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchUserSummary({ payload }) {
  try {
    const res = yield call(API.fetchAllCompanies, payload);
    const { data } = res;
    yield put(actions.fetchUserSummarySuccess(data));
  } catch (err) {
    yield put(actions.fetchUserSummaryFailure(err?.response?.data));
  }
}

export function* handleFetchTotalCompanies({ payload }) {
  try {
    const res = yield call(API.fetchAllCompanies, payload);
    const { data } = res;
    yield put(actions.fetchTotalCompaniesSuccess(data));
  } catch (err) {
    yield put(actions.fetchTotalCompaniesFailure(err?.response?.data));
  }
}
/**
 * Root saga manages watcher lifecycle
 */
export function* userListingSaga() {
  yield takeLatest(actions.fetchUserSummary.type, handleFetchUserSummary);
  yield takeLatest(actions.fetchTotalCompanies.type, handleFetchTotalCompanies);
}
